export default {
  table: {
    noData: 'No data available',
    loading: 'Loading...',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    actions: 'Actions',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selected: 'Selected',
    items: 'items',
    showing: 'Showing',
    to: 'to',
    of: 'of',
    results: 'results',
    perPage: 'Per Page'
  },
  pagination: {
    previous: 'Previous',
    next: 'Next',
    first: 'First',
    last: 'Last',
    page: 'Page',
    of: 'of'
  },
  modal: {
    close: 'Close',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  form: {
    required: 'This field is required',
    invalid: 'Invalid value',
    submit: 'Submit',
    reset: 'Reset',
    cancel: 'Cancel'
  },
  alert: {
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information'
  },
  select: {
    placeholder: 'Select an option...',
    noResults: 'No results found',
    search: 'Search...'
  },
  datePicker: {
    selectDate: 'Select Date',
    today: 'Today',
    clear: 'Clear'
  },
  fileUpload: {
    selectFile: 'Select File',
    dragDrop: 'Drag and drop files here',
    upload: 'Upload',
    remove: 'Remove',
    maxSize: 'Maximum file size',
    allowedTypes: 'Allowed file types'
  }
}

